import { sortAscending } from "../../../utility/utility";

const initialState = {
  modalDeleteData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  searchResults: {},
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  searchOptions: {},

  allDocumentExtractionData: [],
  documentExtractionDataById: {},

  tableLoading: false,
  sidebarLoading: false,
};

const DocumentExtractionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_SEARCH_OPTIONS":
      return {
        ...state,
        searchOptions: payload,
      };
    case "SET_SEARCH_DATA":
      return {
        ...state,
        searchResults: payload.content,
        totalItems: payload.totalItems,
        totalPages: payload.totalPages,
        currentPage: payload.page,
      };
    case "GET_DOCUMENT_EXTRACTION_DATA":
      return {
        ...state,
        allDocumentExtractionData: payload,
      };
    case "GET_DOCUMENT_EXTRACTION_DATA_BY_ID":
      return {
        ...state,
        documentExtractionDataById: payload,
      };

    case "ADD_DOCUMENT_EXTRACTION_DATA": {
      return {
        ...state,
        allDocumentExtractionData:
          state.allDocumentExtractionData.concat(payload),
        //  searchResults:
        // state.allDocumentExtractionData.concat(payload),
      };
    }
    case "UPDATE_DOCUMENT_EXTRACTION_DATA": {
      return {
        ...state,
        allDocumentExtractionData: state.allDocumentExtractionData.map((item) =>
          item.id === payload.id ? { ...payload } : item
        ),
      };
    }
    case "DELETE_DOCUMENT_EXTRACTION_DATA": {
      return {
        ...state,
        allDocumentExtractionData: state.allDocumentExtractionData.filter(
          (item) => item.id !== payload
        ),
        searchResults: state.searchResults.filter(
          (item) => item.id !== payload
        ),
      };
    }
    case "OPEN_MODEL_DELETE":
      return {
        ...state,
        modalDeleteData: action.value,
      };

    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload,
      };

    default:
      return state;
  }
};

export default DocumentExtractionReducer;
